/**
 * Pure predicates used by ConnectedThinDataDetectionMessage to decide whether
 * a suggestion-chip click should be ignored.
 *
 * Brand guide §24. See ThinDataDetectionMessage.tsx for context.
 *
 * Extracted into its own module so the handler's guard branching can be unit-
 * tested directly — React's synthetic-event system blocks onClick on disabled
 * buttons in jsdom, which would otherwise prevent coverage of the positive
 * short-circuit branch when exercised through fireEvent.click.
 */

export type SuggestionChipId = 'widen_date_range' | 'add_more_sessions' | 'continue_anyway'

/**
 * Returns true when a click on the given chip should short-circuit because a
 * previous chat send is still in-flight. "Continue anyway" is always allowed
 * through because it only clears the local warning — it does not send a message.
 */
export function shouldShortCircuitSuggestion(
  isSending: boolean,
  id: SuggestionChipId
): boolean {
  return isSending && id !== 'continue_anyway'
}
